var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 29.714,
    viewBox: "0 0 32 29.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "top-up",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M30.571,3H5.429A1.143,1.143,0,0,0,4.286,4.143V19a1.023,1.023,0,0,0,.021.1A8,8,0,1,0,17.663,27H30.571A3.433,3.433,0,0,0,34,23.571V6.429A3.433,3.433,0,0,0,30.571,3ZM10,30.429a5.714,5.714,0,1,1,5.714-5.714A5.721,5.721,0,0,1,10,30.429ZM31.714,16.714H28.857a1.714,1.714,0,0,1,0-3.429h2.857Zm0-5.714H28.857a4,4,0,0,0,0,8h2.857v4.571a1.145,1.145,0,0,1-1.143,1.143H18a8.009,8.009,0,0,0-8-8,7.929,7.929,0,0,0-3.429.783V5.286h24a1.145,1.145,0,0,1,1.143,1.143Z",
    transform: "translate(0 0)",
    fill: "#329bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M12.5,22a1,1,0,0,1-1,1H10v1.5a1,1,0,0,1-2,0V23H6.5a1,1,0,0,1,0-2H8V19.5a1,1,0,0,1,2,0V21h1.5A1,1,0,0,1,12.5,22Z",
    transform: "translate(1 2.714)",
    fill: "#329bc9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUp);
export default __webpack_public_path__ + "static/media/top-up.6a9056d755131d56450b33c108259367.svg";
export { ForwardRef as ReactComponent };